import { playlistActionTypes } from 'appRedux/actions/playlistCommandCreator';
import { IUserPlaylistItem } from 'appRedux/models/playerModels';

import { IPlaylistState } from 'appRedux/models/playlistModels';

import { IReducer } from './moduleReducerRegistry';

export const playlistInitialState: IPlaylistState = {
  playlist: [],
};

export const playlistReducer: IReducer = (draft, action) => {
  const { type, state } = action;

  switch (type) {
    case playlistActionTypes.ADD_PLAYLIST_ITEM:
      if (draft.app.persistedState.playlist.playlist) {
        const newItem = state as IUserPlaylistItem;
        const existing = draft.app.persistedState.playlist.playlist;
        const doesExist = existing.some((item) => item.slotNumber === newItem.slotNumber);
        if (!doesExist) {
          draft.app.persistedState.playlist.playlist.push(newItem);
        }
      }
      break;
    case playlistActionTypes.REMOVE_PLAYLIST_ITEM:
      draft.app.persistedState.playlist.playlist =
        draft.app.persistedState.playlist.playlist.filter(
          (item) => item.slotNumber !== state
        );
      break;
    case playlistActionTypes.REMOVE_PLAYLIST_ITEMS: {
      const slotNumbersToRemove = new Set(state as number[]);
      draft.app.persistedState.playlist.playlist =
        draft.app.persistedState.playlist.playlist.filter(
          (item) => !slotNumbersToRemove.has(item.slotNumber)
        );
      break;
    }
    case playlistActionTypes.SET_PLAYLIST:
      draft.app.persistedState.playlist.playlist = state as IUserPlaylistItem[];
      break;
    case playlistActionTypes.CLEAR_PLAYLIST:
      draft.app.persistedState.playlist.playlist = [];
      break;
  }
};
